import styled from 'styled-components';
import selectArrow from '../../assets/select-arrow-transparent.png';
// import cssKit from '../../css';

// const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledSelectBox = styled.select`
  padding-right: 50px;

  &:disabled {
    background-color: #e2e2e2;
  }
`;

export const StyledSummarySelect = styled.select`
  border: none;
  padding: 0;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 0;
  height: 25px;
  padding-right: 57px;
  background: url(${selectArrow}) no-repeat right center;
  float: right;
  width: auto;
  top: -5px;
  position: relative;

  &.offer-type-dropdown {
    direction: rtl;
  }

  @media screen and (max-width: 425px) {
    max-width: 60%;
  }

  @media screen and (min-width: 640px) and (max-width: 850px) {
    max-width: 65%;
  }
`;



/** WEBPACK FOOTER **
 ** ./src/components/SelectBox/styles.js
 **/